import React from 'react';
import type { TranslationKey } from '../utils/i18n';
import { FormattedMessage as IntlFormattedMessage } from 'react-intl';

interface FormattedMessageProps extends React.ComponentProps<typeof IntlFormattedMessage> {
  id: TranslationKey;
}

const FormattedMessage = (props: FormattedMessageProps) => <IntlFormattedMessage {...props} />;
export default FormattedMessage;
